export default class Map{

    constructor() {

        this.settings = {
            $map: $('#map')
        };

        this.bindUIActions();

    }

    bindUIActions() {

        if(this.settings.$map.length){
            const latitude = document.querySelector('#lat');
            const longitude = document.querySelector('#long');
            const pin = document.getElementById('map-pin').src;

            if (latitude && longitude) {
                const lat = latitude.dataset.latitude;
                const lng = longitude.dataset.longitude;

                const myOptions = {
                    center: new google.maps.LatLng(lat, lng),
                    zoom: 17,
                    disableDefaultUI: true,
                };

                const map = new google.maps.Map(document.getElementById('map'), myOptions);

                new google.maps.Marker({
                    position: { lat: parseFloat(lat), lng: parseFloat(lng) },
                    map: map,
                    opacity: 1.0,
                    icon: pin
                });

            }
        }
    }
}

new Map();